import Swiper from 'swiper';
import 'swiper_dir/css/swiper.min.css'


let swiper;

document.addEventListener('DOMContentLoaded', () => {
  var mql = window.matchMedia('screen and (max-width: 900px)');

  function checkBreakPoint(mql) {
    if (mql.matches) {
      swiper = new Swiper('.js-slider1', {
        slidesPerView: 'auto',
        spaceBetween:15,
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 1000,
        }
      });
    } else {
      swiper.destroy( true, true );
    }
  }

  mql.addListener(checkBreakPoint);
  // 初回チェック
  checkBreakPoint(mql);
});
